import { useSyncExternalStore } from 'react'

export interface PreviewData {
  id: string
  name: string
  slug: string
  profileType: 'unclaimed' | 'claimed' | 'match'
  rating?: number | null
  reviewCount?: number | null
  styles?: string[]
  address?: string | null
  city?: string | null
  priceFrom?: number | null
  photoUrl?: string | null
  sourceType?: 'google' | 'osm' | 'rivm' | 'kbo' | null
  hasGgdPermit?: boolean
  isOpenNow?: boolean | null
  openUntil?: string | null
  topReview?: string | null
  googlePlaceId?: string | null
  countrySlug?: string
  citySlug?: string
  website?: string | null
  phone?: string | null
  instagramHandle?: string | null
}

type Listener = () => void
const listeners = new Set<Listener>()
let currentData: PreviewData | null = null

function notify() {
  listeners.forEach(l => l())
}

export function openPreview(data: PreviewData): void {
  console.log('[preview] openPreview called:', data.name)
  currentData = data
  notify()
}

export function closePreview(): void {
  currentData = null
  notify()
}

export function usePreviewSheet() {
  const data = useSyncExternalStore(
    (cb) => { listeners.add(cb); return () => listeners.delete(cb) },
    () => currentData,
    () => currentData
  )
  return { data }
}
